import { FC, useId } from "react"

import {
  FormHelperText,
  FormLabel,
  RadioGroup,
  RadioGroupProps,
} from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { getFieldError } from "../field.utils"

interface IProps extends Omit<RadioGroupProps, "name"> {
  name: string
  label?: string
}

const RadioFieldGroup: FC<IProps> = ({ children, name, label, ...props }) => {
  const { control } = useFormContext()
  const { t } = useTranslation()
  const labelId = useId()
  const helperTextId = useId()

  return (
    <Controller
      render={({ field, fieldState: { error: fieldError } }) => {
        const { isError, errorMessage } = getFieldError(fieldError, t)

        return (
          <>
            {label && <FormLabel id={labelId}>{label}</FormLabel>}
            <RadioGroup
              {...props}
              {...field}
              aria-labelledby={label ? labelId : props["aria-labelledby"]}
              aria-describedby={
                isError ? helperTextId : props["aria-describedby"]
              }
            >
              {children}
            </RadioGroup>
            {isError && (
              <FormHelperText id={helperTextId} error>
                {errorMessage}
              </FormHelperText>
            )}
          </>
        )
      }}
      name={name}
      control={control}
    />
  )
}

export default RadioFieldGroup
